import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

import { useIsCampaignAnalyticsEnabled } from './useIsCampaignAnalyticsEnabled';

const flagName = 'merchant-campaigns-analytics-list-page';

export const useIsCampaignAnalyticsForListPageEnabled = () => {
  const { isCampaignAnalyticsEnabled } = useIsCampaignAnalyticsEnabled();

  const { isEmployee, user } = useUser();
  const eligibilityCriteria = {
    is_employee: isEmployee.toString(),
    user_id: user?.id || '',
    user_email: user?.email || '',
    user_country: user?.country || '',
  };

  const { data: featureFlags, isLoading } = useFeatureFlags([flagName], eligibilityCriteria, {
    enabled: !!user,
  });

  const isCampaignAnalyticsForListPageEnabled = !isLoading && featureFlags?.[flagName] === 'on';

  return {
    isCampaignAnalyticsForListPageEnabled: isCampaignAnalyticsEnabled && isCampaignAnalyticsForListPageEnabled,
  };
};
